import React from 'react';
import ReactSelect from 'react-select';

import { defaultStyles, mergeSelectStyles } from '../../utils';

import type { SelectProps, SelectRefType } from '../../types';

import styles from './index.module.scss';

export const Select = React.forwardRef<SelectRefType, SelectProps>(
  (
    {
      options,
      value,
      defaultValue = [],
      styles,
      onChange,
      isMulti,
      isLoading,
      isDisabled,
      isClearable,
      label,
      required,
      errorMessage,
      ...props
    },
    ref,
  ) => {
    const currentStyles = mergeSelectStyles(defaultStyles(), styles);

    return (
      <div className={styles['container']}>
        {label && (
          <label>
            {label} {required && <b>*</b>}
          </label>
        )}

        <ReactSelect
          ref={ref}
          {...props}
          options={options}
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          styles={currentStyles}
          isClearable={isClearable}
          isMulti={isMulti}
          isLoading={isLoading}
          isDisabled={isLoading || isDisabled}
        />

        {errorMessage && <span className={styles['error']}>{errorMessage}</span>}
      </div>
    );
  },
);
